import classNames from "classnames";
import { FC } from "react";
import { toFixedIfNecessary } from "../../utils/toFixedIfNecessary";

type MoneyProps = {
  value: number;
  style?: string[];
  decimals?: number;
};

const Money: FC<MoneyProps> = ({ value, style, decimals }) => {
  let currencyValue = "";

  const formatWithDecimals = (expValue: number) =>
    typeof decimals !== "undefined"
      ? toFixedIfNecessary(value / Math.pow(10, expValue), decimals)
      : value / Math.pow(10, expValue);

  const getBillion = (value: number): string => {
    return value / Math.pow(10, 9) === 1
      ? "1 miljard kr"
      : `${formatWithDecimals(9)} miljarder kr`.replace(".", ",");
  };

  const getMillion = (value: number): string => {
    return value / Math.pow(10, 6) === 1
      ? "1 miljon kr"
      : `${formatWithDecimals(6)} miljoner kr`.replace(".", ",");
  };

  if (value >= Math.pow(10, 9)) {
    currencyValue = getBillion(value);
  }
  if (value >= Math.pow(10, 6) && !currencyValue) {
    currencyValue = getMillion(value);
  }

  if (!currencyValue) {
    const formatter = new Intl.NumberFormat("sv-SE", {
      style: "currency",
      currency: "SEK",
      minimumFractionDigits: 0,
      maximumFractionDigits: 3,
    });
    currencyValue = formatter.format(value);
  }

  return <div className={classNames(style)}>{currencyValue}</div>;
};

export default Money;
